<template>
  <div class="tab-bar-warp">
    <div class="tab-bar">
      <template v-for="item in tabBar">
        <div
          class="item"
          :class="{ active: active === item.key }"
          :key="item.key"
          v-if="!(isIphone && item.key !== 'exam' && item.key !== 'mine')"
          @click="openWin(item.url)"
        >
          <img
            :src="active === item.key ? item.selectedIcon : item.icon"
            alt="icon"
          />
          <p>{{ item.title }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getToken, goToH5LoginSystem } from "@/utils/common.js";
import { isHideIosFunctionality } from "@/utils/isTerminal.js";

export default {
  name: "TabBar",
  props: {
    active: String
  },
  data: function() {
    return {
      tabBar: [
        {
          key: "home",
          title: "首页",
          url: "./index.html",
          icon: require("./img/home.png"),
          selectedIcon: require("./img/homeSelected.png")
        },
        {
          key: "study",
          title: "学习",
          url: "./studyIndex.html",
          icon: require("./img/study.png"),
          selectedIcon: require("./img/studySelected.png")
        },
        {
          key: "exam",
          title: "考试",
          url: "./mineExam.html",
          icon: require("./img/exam.png"),
          selectedIcon: require("./img/examSelected.png")
        },
        {
          key: "mine",
          title: "我的",
          url: "./mineIndex.html",
          icon: require("./img/mine.png"),
          selectedIcon: require("./img/mineSelected.png")
        }
      ]
    };
  },
  computed: {
    isIphone() {
      return isHideIosFunctionality;
    }
  },
  methods: {
    openWin(url) {
      // || url == "./index.html"
      if (getToken()) {
        window.location.href = url;
      } else {
        goToH5LoginSystem();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/var.scss";
.tab-bar-warp {
  z-index: 100;
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
  .tab-bar {
    z-index: 100;
    border-top: 1px solid rgba(243, 245, 247, 1);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: #fff;
    display: flex;
    .item {
      position: relative;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 17px;
        height: 19px;
      }
      p {
        margin: 4px 0;
        color: #969fa9;
        font-size: 10px;
      }
      &.active {
        p {
          color: $--color-primary;
        }
        &::after {
          position: absolute;
          bottom: 0;
          z-index: -1;
          content: "";
          width: 67px;
          height: 57px;
          background-image: url("./img/active.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
